import React, { useContext, useEffect } from "react";
import { ChartContext } from "@contexts/ChartContext";
import { AuthContext } from "@contexts/AuthContext";
import {TVChart} from "@components/TVChart";
import {MarketWatch} from "@components/MarketWatch";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom"; 
import { toast } from "react-toastify";
import styles from "./chart.module.css";
import { TVChartSidebar } from "@components/TVChartSidebar";
import { ToastContainer } from "react-toastify";


export default function Home() {

  const { user, isPremium, isAuthenticated } = useContext(AuthContext);

  


  const {
    currentCandle,
    setCurrentCandle,
    currentSymbol,
    setCurrentSymbol,
    symbols,
    setSymbols,
    symbolsID,
    setSymbolsID,
    layouts,
    setLayouts,
    selectedChart,
    setSelectedChart,
    tvWidgetsComp,
    setTvWidgetsComp,
    widgets,
    setWidgets,
    mainWidget,
    setMainWidget,
    selectedInterval,
    setSelectedInterval,
    replayMode,
    setReplayMode,
    t,
  } = useContext(ChartContext);

  const token = Cookies.get("token");

  useEffect(() => {
    if (t) document.title = `سامانه تکنیکال - تابلوخوانی`;
  }, [t]);

  return (
    <>
          <ToastContainer />

      <div className={`${styles.chartLayout} bg-animated`}>
        <section className={`${styles.sectionColumn} bg-animated`}>
          <section className={styles.sectionRow} dir="ltr">
            <section className={styles.outerBox}>
              <section id="content-dashboard" className={styles.contentDashboard}>
                {isAuthenticated && (
                  <div className={`${styles.defaultTheme} ${styles.splitpanes} ${styles.splitpanesVertical}`}>
                  
                      <TVChart />
           
                    <MarketWatch />
                  </div>
                )}
              </section>
              <TVChartSidebar />
            </section>
          </section>
        </section>
      </div>
    </>
  );
}
